import { render, staticRenderFns } from "./SystemTeamList.vue?vue&type=template&id=36b37393&lang=pug&"
import script from "./SystemTeamList.vue?vue&type=script&lang=js&"
export * from "./SystemTeamList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports